export const taskStyles = {
    "& .task-details-container": {
        p: 0,
        display: "flex",
        flexDirection: "column",
        gap: 5,
    },
    "& .task": { pl: 0, padding: "none", borderBottom: "none" },
    "& .task-details-notes": { maxWidth: "100%", mt: 0, ml: 0 },
    "& .task-details-notes-header": {
        mb: 3,
        mt: -1,
    },
    "& .task-row-entry-index": { display: "none" },
}
